export default __webpack_public_path__ + "static/radarHover-4558a4a50083a961af23017da6c8caac.png";